import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { UserService } from '@app/admin-station/work-center/user/services/user.service';
import { IMessages } from '@app/shared/interfaces/messages';
import { UtilService } from '@shared/services/utils/util.service';

@Component({
  selector: 'cm-notification-item',
  templateUrl: './notification-item.component.html',
  styleUrls: ['./notification-item.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class NotificationItemComponent {
  @Input() public notification!: IMessages;

  @Output() notificationUpdated = new EventEmitter<any>();

  constructor(
    private userService: UserService,
    private utilService: UtilService
  ) { }

  onDownloadFile(fileName: string): void {
    this.utilService.downloadFileFromBackend(fileName).subscribe();
  }

  markAsReadBySingleSelection(notification: IMessages): void {
    if (!notification?.readDate) {
      this.userService.updateMessageReadDate([notification._id]).then(() => this.notificationUpdated.emit(true));
    }
  }
}
